import React, { FC } from 'react';
import cls from './MonthModePosition.module.css';
import classNames from 'classnames';
import moment from 'moment';
import { PositionIItem } from '../../../../../../UI/PositionItem/PositionIItem';
import { useSelector } from 'react-redux';

export const MonthItemPosition = ({ position, month, isPlanFact }) => {
    const { settings } = useSelector((state) => state.gantReducer);

    if (!position) return null;

    const positionDate = moment(position.planned.start_date).format('DD.MM.YYYY');

    const isShowPosition = !settings.isShowMHD && position?.type !== 'labor';

    const nowDate = moment().format('DD.MM.YYYY');

    const isRenderDays =
        month.date === moment(position.planned.start_date).format('MM.YYYY') ||
        month.date === moment().format('MM.YYYY');

    let isPlanFactShow = true;

    if (isPlanFact) {
        isPlanFactShow = isPlanFact && !!position?.planned.start_date;
    }

    if (!isPlanFactShow) {
        return null;
    }

    if (isShowPosition) {
        return null;
    }

    return (
        <>
            <div
                className={classNames(cls.month, { [cls.factWrapper]: isPlanFact })}
                style={{ width: 7 * month.dayInMonth }}
            >
                {isRenderDays &&
                    month.days.map((day, i) => (
                        <div
                            className={classNames(cls.day, {
                                [cls.factWrapper]: isPlanFact,
                                [cls.nowDate]: day.date === nowDate,
                            })}
                            key={day.date + i + position.guid}
                        >
                            {day.date === positionDate && (
                                <PositionIItem isPlanFact={isPlanFact} position={position} />
                            )}
                        </div>
                    ))}
            </div>
        </>
    );
};
